var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiocloudLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14315",
    "data-name": "Group 14315",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.998,
    height: 38.107,
    viewBox: "0 0 55.998 38.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20973",
    "data-name": "Path 20973",
    d: "M0,13.279A13.28,13.28,0,0,1,23.615,4.94L20.974,7.185a9.814,9.814,0,1,0-2.48,14.41,11.383,11.383,0,0,0,1.765-1.416,9.86,9.86,0,0,0,1-1.187l.016.011c1.647-1.958,3.443-4.269,5.511-6.929l0,0,.036-.046.095-.122,0,0c1.548-1.989,3.3-4.243,5.211-6.63a14.348,14.348,0,0,1,2.624-2.591,9.743,9.743,0,0,1,4.6-2.089l.192,1.722h-.578v1.9a10.716,10.716,0,0,0-4.083,3.156C32.916,9.838,31.153,12.1,29.6,14.1l-.007.009-.032.039c-2.17,2.793-4.047,5.209-5.685,7.133l-.084.11a9.056,9.056,0,0,1-1.062,1.215,13.247,13.247,0,0,1-7.363,3.788l-.055.01h0A13.29,13.29,0,0,1,0,13.279Z",
    transform: "translate(0 11.548)",
    fill: "#76aa47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20974",
    "data-name": "Path 20974",
    d: "M22.584,37.046a13.227,13.227,0,0,1-4.239-2.887l2.661-2.241a9.813,9.813,0,1,0,2.409-15.883L16.225,18.1l-.043-.015A13.358,13.358,0,0,1,26.536,11.6a12.128,12.128,0,0,0-23.185.929A13.193,13.193,0,0,0,0,11.648a15.593,15.593,0,0,1,30.2.115,13.282,13.282,0,1,1-7.619,25.282Zm5.592-25.494Zm-.075,0Zm-.076,0Zm-.078,0Zm-.159,0Z",
    transform: "translate(14.936 0.001)",
    fill: "#464b56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20966",
    "data-name": "Path 20966",
    d: "M20.484,55.815,15,51.2l5.2,1.732L25.97,46Z",
    transform: "translate(-6.34 -27.492)",
    fill: "#464b56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiocloudLogo);
export default __webpack_public_path__ + "static/media/biocloud_logo.4f323748fae68363350d52e08d98cd67.svg";
export { ForwardRef as ReactComponent };